import { getCommunityDetailQueryKey } from '@pba/react-network';
import { useQueryClient } from '@tanstack/react-query';
import { Entity } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getChannelsFeatureQueryKey } from 'features/channels/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getNodeOrganizationsInfiniteQueryKey } from 'features/organizations/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getProfileQueryKey } from 'features/users/queries/keys';
import { joinCommunity } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error);
};

export const useJoinCommunity = () => {
  const queryClient = useQueryClient();

  return useMutation<Entity, { id: string; reason?: string }>({
    defaultMutateOnError,
    async mutationFn({ id, reason }) {
      const communityResponse = await joinCommunity({ body: { reason }, routeParams: { id } });

      return new Entity(communityResponse.data);
    },
    async onSettled(_data, _error, { id }) {
      await queryClient.invalidateQueries({ queryKey: getCommunityDetailQueryKey({ id }) });
    },
    async onSuccess() {
      // TODO: Invalidate CommunitiesInfiniteQuery when it is added to communities-new.
      await queryClient.invalidateQueries({ queryKey: getChannelsFeatureQueryKey() });
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
      await queryClient.invalidateQueries({ queryKey: getNodeOrganizationsInfiniteQueryKey({}) });
    },
  });
};
